import { Unit } from 'uom';
import { getAllowedUnits } from 'src/modules/user-input/calcV100/unitsMapping.ts';
import { RegionsEnum } from 'src/generated/operations.ts';

const unitsSet = new Set<Unit.Unit<unknown>>();
Object.values(getAllowedUnits(RegionsEnum.Eu))
    .forEach((curr) => {
        curr.forEach((unit) => {
            unitsSet.add(unit);
        });
    });
Object.values(getAllowedUnits(RegionsEnum.Am))
    .forEach((curr) => {
        curr.forEach((unit) => {
            unitsSet.add(unit);
        });
    });

const unitsArray = [...unitsSet.values()];

export function getUnitByName(name: string, defaultUnit: Unit.Unit<unknown>) {
    const curr = unitsArray.find((unit) => unit.name === name);
    return curr || defaultUnit;
}
